import { DetailsListItem } from '#/components/DetailsList/Item/DetailsListItem';
import type {
  IanaTimezoneString,
  ApiISODateString,
  ApiISOTimeString,
} from '#/api/types/ApiTypedDate';
import { useI18n } from '#/i18n/hooks/useI18n';
import { ListingIsoDateAndTime } from '#/modules/listing/components/Date/ListingIsoDateAndTime';

type Props = {
  startDate: ApiISODateString;
  startTime: ApiISOTimeString | null;
  endDate: ApiISODateString | null;
  endTime: ApiISOTimeString | null;
  timezone: IanaTimezoneString | null;
};

export function ListingIsoDateDetailsListItems({
  startDate,
  startTime,
  endDate,
  endTime,
  timezone,
}: Props) {
  const { i18n } = useI18n();

  if (startDate === endDate) {
    return (
      <DetailsListItem
        title={i18n('Date')}
        iconName="calendar"
        value={
          <ListingIsoDateAndTime
            date={startDate}
            time={(() => {
              if (!startTime || !timezone) return null;

              return endTime
                ? { type: 'range', start: startTime, end: endTime, timezone }
                : { type: 'single', value: startTime, timezone };
            })()}
          />
        }
      />
    );
  }

  return (
    <>
      <DetailsListItem
        title={i18n('Start Date')}
        iconName="hourglass"
        value={
          <ListingIsoDateAndTime
            date={startDate}
            time={
              startTime && timezone
                ? { type: 'single', value: startTime, timezone }
                : null
            }
          />
        }
      />

      {endDate && (
        <DetailsListItem
          title={i18n('End Date')}
          iconName="hourglass"
          value={
            <ListingIsoDateAndTime
              date={endDate}
              time={
                endTime && timezone
                  ? { type: 'single', value: endTime, timezone }
                  : null
              }
            />
          }
        />
      )}
    </>
  );
}
